import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SearchIcon from '@mui/icons-material/Search';
import { StateContext } from '../../Middleware/context/StateProvider';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../Middleware/Firebase/firebase';
import logo from '../../IMG/touaki.png'
import '../../Css/Header.css';

function Header() {
  const { state } = useContext(StateContext);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsub();
  }, []);

  const handleAuth = () => {
    if (user) {
      signOut(auth);
    } else {
      navigate('/login');
    }
  };

  return (
    <header className="header">
      {/* LOGO */}
      <Link to="/" className="header__logo">
        <span className="logo-text">TouAki</span>
        <img
          src={logo}
          alt="TouAki"
          className="logo-img"
        />
      </Link>

      {/* SEARCH */}
      <div className="header__search">
        <input
          type="text"
          placeholder="Buscar produtos..."
        />
        <SearchIcon  />
      </div>

      {/* NAV */}
      <nav className="header__nav">
        <div className="nav__item" onClick={handleAuth}>
          <span>Olá, {user ? user.email : 'Visitante'}</span>
          <strong>{user ? 'Sair' : 'Entrar'}</strong>
        </div>

        <div className="nav__item">
          <span>Devoluções</span>
          <strong onClick={(e)=>{navigate('/User/Orders')}} >& Pedidos</strong>
        </div>

        <Link to="/cart" className="nav__cart">
          <ShoppingCartIcon />
          <span className="cart-count">{state?.basket?.length || 0}</span>
        </Link>
      </nav>
    </header>
  );
}

export default Header;
